import React, { ReactNode, useCallback, useMemo, useState } from "react"

import { ResultType } from "../../constants/resultType"
import { ServicesConfig } from "../../typings/ServicesConfig"
import {
  parseQueryStringFromURL,
  parseServicesConfigFromPostMessage,
} from "../../utils/parameters"
import AppStateContext, { AppStateContextType } from "./AppStateContext"

interface Props extends AppStateContextType {
  children: ReactNode
  activeTab: ResultType
  query: string
  indexes: ResultType[]
}

const AppStateContextProvider = ({
  children,
  activeTab,
  query,
  indexes,
}: Props) => {
  const appConfig = useMemo(
    () => parseQueryStringFromURL(window.location.href),
    [],
  )

  const [servicesConfig, setConfig] = useState<ServicesConfig>(
    parseServicesConfigFromPostMessage(),
  )

  const setServicesConfig = useCallback((servicesConfig: ServicesConfig) => {
    setConfig(parseServicesConfigFromPostMessage(servicesConfig))
  }, [])

  const value = useMemo(
    () => ({
      ...appConfig,
      servicesConfig,
      indexes,
      activeTab,
      query,
      setServicesConfig,
    }),
    [appConfig, servicesConfig, indexes, activeTab, query, setServicesConfig],
  )

  return (
    <AppStateContext.Provider value={value}>
      {children}
    </AppStateContext.Provider>
  )
}

export default AppStateContextProvider
